import { FilterOutlined } from "@ant-design/icons";
import { SelectProps } from "antd";
import { AssignmentType } from "tm-shared/types";

import FlexContainer from "@/components/FlexContainer";
import { ASSIGNMENT_VOCABULARY } from "@/constants/ui/assignment";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { setAssignmentsFilter } from "@/store/slices/ui";

import { StyledContainer, StyledSelect } from "./Styled";

const FILTER_OPTIONS = Object.values(ASSIGNMENT_VOCABULARY);

export const AssignmentFilter = () => {
    const dispatch = useAppDispatch();

    const { filter: currentFilter } = useAppSelector(
        (s) => s.ui.assignments.page,
    );

    const onFilterChange: SelectProps["onChange"] = (value) => {
        const v = (value ?? null) as AssignmentType | null;
        dispatch(setAssignmentsFilter(v));
    };

    return (
        <StyledContainer>
            <StyledSelect
                value={currentFilter}
                onChange={onFilterChange}
                listHeight={400}
                allowClear
                size="large"
                placeholder={
                    <FlexContainer justifyContent="flex-start" gap="12px">
                        <FilterOutlined />
                        <p>Тип доручення</p>
                    </FlexContainer>
                }
            >
                {FILTER_OPTIONS.map(({ label, icon: Icon, value }) => (
                    <StyledSelect.Option key={value} value={value}>
                        <FlexContainer justifyContent="flex-start" gap="12px">
                            <Icon />
                            <p>{label}</p>
                        </FlexContainer>
                    </StyledSelect.Option>
                ))}
            </StyledSelect>
        </StyledContainer>
    );
};
